import { useRecoilState } from 'recoil'
import { NavLink } from 'react-router-dom'
import clsx from 'clsx'
import IconEye from '@/components/icons/IconEye'
import IconEyeOff from '@/components/icons/IconEyeOff'
import IconOrderlySmartContract from '@/components/icons/IconOrderlySmartContract'
import { showWalletBalanceState } from '@/recoil/Wallet'
import numberFormat from '@/utils/numberFormat'

import './WalletBalance.css'

export default function WalletBalance({
  isDeFiWallet = false,
  isLoading,
  label,
  balance,
  currency,
  actionCallback = () => {}
}) {
  const [showWalletBalance, setShowWalletBalance] = useRecoilState(
    showWalletBalanceState
  )
  return (
    <div
      className={clsx('wallet-balance', {
        'defi-wallet': isDeFiWallet
      })}
    >
      <div className="wallet-balance-info-row">
        <div className="wallet-label">{label}</div>
        {showWalletBalance ? (
          <IconEye
            className="show-wallet-balance-button"
            onClick={() => setShowWalletBalance(false)}
          />
        ) : (
          <IconEyeOff
            className="show-wallet-balance-button"
            onClick={() => setShowWalletBalance(true)}
          />
        )}
      </div>
      <div className="wallet-balance-info">
        <span className="total-balance-label">
          {showWalletBalance ? numberFormat(balance, 2) : '******'}
        </span>
        <span className="total-balance-currency">{currency}</span>
      </div>
      <div className="wallet-balance-action">
        {isDeFiWallet ? (
          <>
            <div />
            <div
              className="wallet-balance-action-button"
              onClick={actionCallback}
            >
              Disconnect Wallet
            </div>
          </>
        ) : (
          <>
            <a
              className="orderly-doc-link"
              target="_blank"
              href="https://docs.orderly.network/build-on-orderly/host-a-gui/smart-contract-api/smart-contract-addresses"
              rel="noopener noreferrer"
            >
              <IconOrderlySmartContract className="icon-orderly" />
            </a>
            <NavLink className="wallet-history-link" to="/wallet/history">
              Wallet History
            </NavLink>
          </>
        )}
      </div>
    </div>
  )
}
